var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSeturPay = function SvgSeturPay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "setur-pay_svg__a",
    d: "M0 0h35v35H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "setur-pay_svg__c",
    d: "M0 7.728 34.182 0l7.778 33.965-34.183 7.728z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "setur-pay_svg__e",
    d: "M0 7.728 34.182 0l7.778 33.965-34.183 7.728z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "setur-pay_svg__g",
    d: "M0 0h21v10H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "setur-pay_svg__i",
    d: "M0 0h21v3H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "setur-pay_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#setur-pay_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#setur-pay_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.556 -3.32)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "setur-pay_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#setur-pay_svg__c"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#setur-pay_svg__d)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "setur-pay_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#setur-pay_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.877 7.299c7.53-1.703 15.024 2.983 16.737 10.465 1.713 7.483-3.002 14.929-10.532 16.631S9.058 31.412 7.345 23.929C5.632 16.447 10.347 9.001 17.877 7.3Zm6.38 27.862a14.843 14.843 0 0 1-10.356-1.428 14.729 14.729 0 0 1-5.711-5.53l-.863.496a15.72 15.72 0 0 0 6.097 5.903 15.84 15.84 0 0 0 11.054 1.524l-.22-.965Zm12.134-10.97a15.445 15.445 0 0 0-.034-6.82l-.972.22c.487 2.125.498 4.274.033 6.387a14.701 14.701 0 0 1-7.245 9.695l.486.866A15.696 15.696 0 0 0 36.39 24.19ZM30.649 8.466a15.722 15.722 0 0 0-11.664-3.166c-.502.064-1.008.154-1.504.266l.22.966c.466-.105.94-.19 1.412-.25A14.73 14.73 0 0 1 30.038 9.25l.61-.783ZM9.053 12.183l-.805-.584a15.592 15.592 0 0 0-2.646 12.724l.972-.22a14.608 14.608 0 0 1 2.48-11.92Zm29.018 4.8a17.34 17.34 0 0 0-6.08-9.688 17.527 17.527 0 0 0-14.9-3.43l.22.964a16.531 16.531 0 0 1 14.054 3.237 16.353 16.353 0 0 1 5.734 9.137c.393 1.716.508 3.466.342 5.202l.992.093c.176-1.84.054-3.696-.362-5.515ZM7.19 11.786a16.538 16.538 0 0 1 5.776-5.312l-.482-.867A17.531 17.531 0 0 0 6.36 11.24a17.435 17.435 0 0 0-2.798 7.626l.99.113a16.448 16.448 0 0 1 2.64-7.193Zm21.087 24.9a17.503 17.503 0 0 0 6.846-5.552l-.805-.585a16.507 16.507 0 0 1-9.672 6.315c-2.752.622-5.63.535-8.32-.251a16.628 16.628 0 0 1-7.466-4.59 16.382 16.382 0 0 1-4-7.532l-.973.22a17.375 17.375 0 0 0 4.243 7.987 17.625 17.625 0 0 0 7.915 4.864c2.853.835 5.904.927 8.822.267a17.743 17.743 0 0 0 3.41-1.144Z",
    fill: "#ED291D",
    fillRule: "nonzero",
    mask: "url(#setur-pay_svg__f)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 16)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "setur-pay_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#setur-pay_svg__g"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 .009v6.217c0 1.959 1.572 3.731 3.5 3.731h14c1.93 0 3.5-1.772 3.5-3.73V.008H0ZM2.8 2.85h3.5v.71H2.8v-.71Zm7 2.843h-7V4.272h7v1.422Z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#setur-pay_svg__h)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "setur-pay_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#setur-pay_svg__i"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.5.001h-14C1.57.001 0 1.171 0 2.928h21C21 1.172 19.43 0 17.5 0Z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#setur-pay_svg__j)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M9 17h8v7H9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.378 19-.235.875H20l-.21.798h-.857l-.244.847a1.764 1.764 0 0 0-.063.34c0 .137.076.244.34.244.105 0 .332-.003.454-.024l-.214.828c-.193.061-.61.092-.89.092-.8-.003-1.19-.284-1.186-.694.004-.19.034-.38.088-.566l.295-1.07H17l.214-.795h.513l.151-.588 1.5-.287Zm1.947 1-.282 1.547a2 2 0 0 0-.042.369c0 .138.056.264.21.264.248 0 .472-.323.578-.876L22.027 20H23l-.523 2.936h-.853l.045-.446h-.011c-.302.381-.632.51-.956.51-.484-.003-.705-.308-.702-.814 0-.189.02-.376.059-.56L20.352 20h.973Zm4.675.006-.317.99h-.157c-.719 0-.96.47-1.085 1.009l-.224.995L23 22.997l.652-2.95h1.155l-.133.6h.021c.258-.379.618-.65 1.1-.647.068 0 .137.001.205.006Zm-13.719-2.005.156.007a3.319 3.319 0 0 1 1.399.406l-.228 1.275v.016l-.112-.049c-.267-.123-.698-.311-1.094-.363l.102-.568-1.185.656.89.976.098-.545s.758.188 1.2.483c.34.26.532.62.486 1.126-.098 1.162-1.29 1.652-2.422 1.57a5.109 5.109 0 0 1-1.556-.386l.252-1.385c.309.178.964.474 1.69.542l-.098.535 1.184-.655-.893-.977-.095.555s-.915-.169-1.448-.457c-.392-.244-.644-.614-.602-1.123.101-1.155 1.29-1.716 2.432-1.632ZM15.86 20c.64.003 1.144.33 1.141.921-.003.718-.708 1.008-1.986.968a.338.338 0 0 0 .112.192c.12.095.31.15.553.15a2.25 2.25 0 0 0 1.002-.225l-.157.798c-.486.198-.81.198-1.126.195-.906-.002-1.401-.447-1.398-1.248.003-.876.687-1.757 1.859-1.751Zm-.136.718c-.295-.008-.552.184-.606.453.655.009.88-.077.88-.258v-.009c.004-.097-.098-.186-.274-.186Z",
    fill: "#E2231B",
    fillRule: "nonzero"
  }))));
};
export default SvgSeturPay;